
import { eventBus, EVENTS } from './commons/EventBus.js';
import API from "./commons/Api.js";
import {Paginator} from "./commons/paginator.js";

eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
    const template=data.template;


    if(template == "classifiche"){
        initPaginatoreItalia();
        initPaginatoreEuropa();
        initPaginatoreUsa();
    } else if(template == "dettaglio_classifica"){
        initPaginatoreAltreClassifiche();
    } else{
        return;
    }

});

function initPaginatoreItalia(){

    var breakpoints = [
        { maxWidth: 550, perPage: 2 },
        { maxWidth: 1100, perPage: 3 },
        { perPage: 4 }
    ];

    new Paginator($('.paginatore_italia'), {
        total: 4 ,
        breakpoints: breakpoints,
        cssVar: '--it_paginator',
        swipeElementSelector: '#classifiche-single_classifica_italia'
    });

}


function initPaginatoreEuropa(){


    var breakpoints = [
        { maxWidth: 550, perPage: 2 },
        { maxWidth: 1100, perPage: 3 },
        { perPage: 4 }
    ];

    new Paginator($('.paginatore_europa'), {
        total: 4 ,
        breakpoints: breakpoints,
        cssVar: '--eu_paginator',
        swipeElementSelector: '#classifiche-single_classifica_europa'
    });

}

function initPaginatoreUsa(){

    var breakpoints = [
        { maxWidth: 550, perPage: 2 },
        { maxWidth: 1100, perPage: 3 },
        { perPage: 4 }
    ];

    new Paginator($('.paginatore_usa'), {
        total: 4 ,
        breakpoints: breakpoints,
        cssVar: '--usa_paginator',
        swipeElementSelector: '#classifiche-single_classifica_usa'
    });

}

function initPaginatoreAltreClassifiche(){

    var breakpoints = [

        { maxWidth: 550, perPage: 2 },
        { maxWidth: 800, perPage: 3 },
        { maxWidth: 1100, perPage: 4 },
        { perPage: 4 }
    ];

    new Paginator($('.paginatore_altre'), {
        total: 6 ,
        breakpoints: breakpoints,
        cssVar: '--altre_paginator',
        swipeElementSelector: '#dettaglio_classifica-altre_classifiche'
    });

}
